import styled from "styled-components";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const BadgeWinesDescription = styled.p<{ addTopMargin: boolean }>`
  font-size: 18px;
  line-height: 24px;
  ${breakpoints.xsDown} {
    font-size: 14px;
    line-height: 20px;
    text-align: ${({ addTopMargin }) => (addTopMargin ? "center" : "left")};
  }
  font-family: ${fonts.fontBauRegular};
  margin-bottom: 25px;
  padding: 0 20px;
  margin-top: ${({ addTopMargin }) => (addTopMargin ? "25px" : "0px")};
`;

export const BadgeRelatedWinesStatsWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 0 20px 20px;
`;

export const BadgeRelatedWinesStats = styled.p`
  color: ${colors.black};
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  font-family: ${fonts.fontBauRegular};
  background-color: ${colors.whiteTransparent};
  width: 100%;
  padding: 16px;
  ${breakpoints.xsDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;
